export default { inStock: 'IN_STOCK' };
